import GcButton from '@garmin/components-global/src/components/GcButton/index.vue';

export default {
  name: 'PcPromoBanner',
  components: {
    GcButton,
  },
  props: {
    link: {
      type: String,
      default: '',
    },
    desktopImg: {
      type: String,
      default: '',
    },
    mobileImg: {
      type: String,
      default: '',
    },
    imgAlt: {
      type: String,
      default: '',
    },
  },
  computed: {
    shouldDisplay() {
      return this.desktopImg && this.mobileImg;
    },
  },
};
